import React, {useMemo} from "react";

// Components
import {GroupButtons} from "../../../organizationManagement/components/GroupButtons";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {BeautifulTable} from "../BeautifulTable";
import {BeautifulPieChart} from "../BeautifulPieChart";

import {getGroupPathByName} from "../../model/dashboardHelpers";
import {countByRegion} from "../../model/dashboardAnalytics";

type RegionCountRow = { region: string; count: number };

export const RegionSummary = ({cases, selectedGroup, onChangeSelectedGroup}) => {
  const regionCountArray = useMemo(() => {
    const groupPath = getGroupPathByName(selectedGroup)

    const filteredCases = cases.filter(c => {
      if (groupPath === '') return true;
      return (c.category === groupPath)
    });

    return countByRegion(filteredCases)
  }, [selectedGroup, cases]);

  return (
    <DashboardCard>
      <Typography variant="subtitle">
        個案鄉鎮市統計
      </Typography>

      <GroupButtons
        selectedGroup={selectedGroup}
        onChangeSelectedGroup={onChangeSelectedGroup}
      />

      <BeautifulTable<RegionCountRow>
        rows={regionCountArray}
        getRowKey={(row) => row.region}
        columns={[
          {
            key: 'question',
            header: <Typography variant="body">縣市</Typography>,
            render: (row) => <Typography variant="body">{row.region}</Typography>,
            cellClassName: 'text-gray-800',
          },
          {
            key: 'avg',
            header: <Typography variant="body">人數</Typography>,
            align: 'right',
            headerClassName: 'text-nowrap',
            cellClassName: 'font-medium text-gray-700',
            render: (row) => <Typography variant="bodyBold">{row.count}</Typography>,
          },
        ]}
      />

      <BeautifulPieChart
        dataKey="count"
        nameKey="region"
        data={regionCountArray}
      />
    </DashboardCard>
  )
}
